module.exports = __webpack_public_path__ + "media/images/front/icons_sp-f514ab6631d5e2cbde0f50e9e8c9e83d.png";